<ion-content scrollbar class="space-add-reservation__container">
  <div *ngIf="!p.renderMobile" class="breadcrumb">
    <app-breadcrumb></app-breadcrumb>
  </div>

  <app-space-date-filter
    (reloadSpaces)="loadSpaces($event)"
    (resetSpaces)="resetSpaces()"
    [options]="spaceDateFilterOptions"
    [events]="eventsSubject.asObservable()"
  ></app-space-date-filter>

  <div class="space-add-reservation__list-header">
    <div>
      <span
        class="space-add-reservation__list-header-text"
        *ngIf="!p.renderMobile"
      >
        {{ "SPACE.VACANCIES_FOUND" | translate }}
      </span>
      <span
        class="space-add-reservation__list-header-counter"
        *ngIf="!p.renderMobile"
      >
        <ng-container *ngIf="spacesReset">
          {{ "SPACE.FILTER_DATE" | translate }}
        </ng-container>
        <ng-container *ngIf="!spacesReset">
          {{ spaceService?.spaces ? spaceService.spaces.length : "0" }}
        </ng-container>
      </span>
    </div>
    <div class="display-flex ion-align-items-center" *ngIf="showFilterButtons">
      <span class="space-add-reservation__list-header-buttons-label">
        {{ "SPACE.CHANGE_VIEW" | translate }}
      </span>
      <app-select-buttons
        [keyValueList]="filterButtons"
        (selectedChange)="onChangeSpacesVisualisation($event)"
        [selectedValue]="filterButtons[0].value"
        [defaultSelectedValue]="filterButtons[0].value"
        [disableDeselect]="true"
        [whiteBackground]="true"
        [resetButtons]="resetButtonsSubject.asObservable()"
      >
      </app-select-buttons>
    </div>
  </div>

  <app-pagination-client-side
    [ngClass]="{ 'height-0': showLoader || showSpaceMap }"
    [columns]="columnsDefinitionSpace"
    [options]="options"
    [componentRef]="componentRef"
    (rowsLoaderReady)="rowsLoaderServiceReady($event)"
    (actionRequest)="onBookSpace($event)"
    (refreshRequest)="loadSpaces(filterDetails)"
  >
  </app-pagination-client-side>

  <app-space-map
    [workingMode]="workingMode.BOOK"
    [freeSpacesLoaded]="spacesLoadedSubject.asObservable()"
    [resetSpaces]="spacesResetSubject.asObservable()"
    (onBookSpace)="onBookSpace($event)"
    *ngIf="showSpaceMap"
  ></app-space-map>

  <!-- <div class="spin--full" *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </div> -->
</ion-content>
